import styles from './Trends.module.css'
export function Lifestyle(){
    return(
        <section className={`section ${styles.incoLivingRoom}`}>
        <div className="container">
            <div className={styles.trandsHeading}>
                <p>
                    <span><svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="m25.996.728-.517 5.02c-.06.551-.732.788-1.118.4l-1.224-1.23-7.708 7.754c-.484.486-1.336.486-1.82 0L9.365 8.4 2.19 15.621a1.28 1.28 0 0 1-1.814 0c-.501-.504-.501-1.322 0-1.83l8.08-8.129c.484-.487 1.336-.487 1.815 0l4.25 4.271 6.802-6.842-1.434-1.442c-.39-.392-.154-1.068.393-1.124l4.991-.52a.657.657 0 0 1 .723.723z" fill="#EB5976"/>
                    </svg></span>
                    <span className={`${styles.trandsHead} font16 text222"`}>Lifestyle </span>
                </p>
                <a href="" className="link font16">View All</a>
            </div>
            <div className={styles.inLivingBox}>
                <div className={styles.inLivingTiles}>
                    <figure className="mb12">
                        <img className="img-responsive" src="/assets/images/IncotaendsLivig1.png" alt=""/>
                    </figure>
                    <p className="font16 text222 lineHeight20 mb12 lineClamp"> Simple Two Colour
                        Combination For Living Room
                        Work Best: Here’s Why</p>
                        <a href="" className="link font10">LIVING ROOM</a>
                </div>
                <div className={styles.inLivingTiles}>
                    <figure className="mb12">
                        <img className="img-responsive" src="/assets/images/incoLivingtrands2.png" alt=""/>
                    </figure>
                    <p className="font16 text222 lineHeight20 mb12 lineClamp">10 Beautiful Hall Partition
                        Designs That Can Spruce up
                        Your Living Room</p>
                        <a href="" className="link font10">LIVING ROOM</a>
                </div>
                <div className={styles.inLivingTiles}>
                    <figure className="mb12">
                        <img className="img-responsive" src="/assets/images/incoLivingtrands3.png" alt=""/>
                    </figure>
                    <p className="font16 text222 lineHeight20 mb12 lineClamp">15 Simple & Stunning Living
                        Room Designs That are Made
                        for Indian Minimalists</p>
                        <a href="" className="link font10">LIVING ROOM</a>
                </div>
                <div className={styles.inLivingTiles}>
                    <figure className="mb12">
                        <img className="img-responsive" src="/assets/images/incotarndsLiving4.png" alt=""/>
                    </figure>
                    <p className="font16 text222 lineHeight20 mb12 lineClamp">20 Gorgeous Living Room
                        Designs From Interior
                        Company to Inspire You</p>
                        <a href="" className="link font10">LIVING ROOM</a>
                </div>
                <div className={styles.inLivingTiles}>
                    <figure className="mb12">
                        <img className="img-responsive" src="/assets/images/incoLivingtrands5.png" alt=""/>
                    </figure>
                    <p className="font16 text222 lineHeight20 mb12 lineClamp">Expand Your Small Living
                        Room With These 8 Expert
                        Ideas</p>
                        <a href="" className="link font10">LIVING ROOM</a>
                </div>
            </div>
        </div>
    
     </section>
    )
}